<template>
  <ToolAdmin
    :user="user"
    tool-id="CustomerServiceAgentAssist"
    tool-name="Agent Assist"
    tool-icon="mdi-robot"
  />
</template>

<script>
import ToolAdmin from './ToolAdmin.vue'

export default {
  name: 'AgentAssistAdmin',
  components: {
    ToolAdmin
  },
  props: ['user']
}
</script> 